import { combineReducers } from "@reduxjs/toolkit";
import ConfigurationSliceReducer from "./configuration_slice";
import CustomerEMRSliceReducer from "./customer_emr_slice";
import CustomerProfileSliceReducer from "./customer_profile_slice";
import InventoryManagementSliceReducer from "./inventory_slice";
import OrderManagementSliceReducer from "./order_management_slice";
import PatientWaitingListSliceReducer from "./patient_waiting_list_slice";
import LabReportListSliceReducer from "./lab_report_slice";
import CouponServiceSliceReducer from "./coupon_service_slice";
import RotaSliceReducer from "./rota_slice";
import SlotsSliceReducer from "./slots_slice";
import CalendarViewSliceReducer from "./staff_calendar_slice";
import CartSliceReducer from "./cart_slice";
import MembershipSliceReducer from "./membership.slice";
import MembershipExtensionSliceReducer from "./membership_extension.slice";
import CertificateSliceReducer from "./certificate_slice";
import MappingsSliceReducer from "./mapping_slice";
import TilesSliceReducer from "./tiles_slice";

export type AuthReducerStateKeys =
  | "CUSTOMER_PROFILE"
  | "PATIENT_WAITING_LIST"
  | "LAB_REPORT"
  | "SLOTS"
  | "ORDER_MANAGEMENT"
  | "ROTA"
  | "CUSTOMER_EMR"
  | "COUPON_SERVICE"
  | "CALENDAR_VIEW"
  | "INVENTORY"
  | "CART_MANAGEMENT"
  | "MEMBERSHIP_SETUP"
  | "MEMBERSHIP_EXTENSION"
  | "CERTIFICATES_TAB"
  | "DATA_MAPPINGS"
  | "TILES_PAGE";

const AuthCombinerReducer = combineReducers({
  CUSTOMER_PROFILE: CustomerProfileSliceReducer,
  PATIENT_WAITING_LIST: PatientWaitingListSliceReducer,
  LAB_REPORT: LabReportListSliceReducer,
  SLOTS: SlotsSliceReducer,
  ORDER_MANAGEMENT: OrderManagementSliceReducer,
  CONFIGURATION: ConfigurationSliceReducer,
  ROTA: RotaSliceReducer,
  COUPON_SERVICE: CouponServiceSliceReducer,
  CUSTOMER_EMR: CustomerEMRSliceReducer,
  STAFF_CALENDAR: CalendarViewSliceReducer,
  INVENTORY: InventoryManagementSliceReducer,
  CART_MANAGEMENT: CartSliceReducer,
  MEMBERSHIP_SETUP: MembershipSliceReducer,
  MEMBERSHIP_EXTENSION: MembershipExtensionSliceReducer,
  CERTIFICATES_TAB: CertificateSliceReducer,
  DATA_MAPPINGS: MappingsSliceReducer,
  TILES_PAGE: TilesSliceReducer,
});

export default AuthCombinerReducer;
